module.exports = __webpack_public_path__ + "media/images/welcome_john-de4d47dd8456c7ecc0bde93a1c7bf867.png";